import styled from "styled-components";

import { Row } from "components/common";

const Tooltip = styled.div`
  display: none;
  position: absolute;
  top: 52px;
  /*     right: 2px; */
  background-color: #f9f9f9;
  /*   width: 120px; */
  background-color: #cc5248;
  border: 1px solid #fff;
  color: #fff;
  text-align: center;
  padding: 4px 12px;
  border-radius: 6px;
  font-size: 12px;
  position: absolute;
  z-index: 1;
`;

const Container = styled(Row)`
  font-size: 12px;
  & > svg {
    color: #ddd;
  }
  &:hover > svg {
    color: #fff;
  }
  &:hover ${Tooltip} {
    display: block;
  }
  &:hover {
    cursor: pointer;
  }
`;

const VerticalDivider = styled.div`
  width: 1px;
  background-color: #555;
  height: 30px;
  margin: 0px 8px;
`;

export { Container, Tooltip, VerticalDivider };
